import { render, staticRenderFns } from "./ProfileGallery.vue?vue&type=template&id=537139fd&scoped=true&"
import script from "./ProfileGallery.vue?vue&type=script&lang=js&"
export * from "./ProfileGallery.vue?vue&type=script&lang=js&"
import style0 from "./ProfileGallery.vue?vue&type=style&index=0&id=537139fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537139fd",
  null
  
)

export default component.exports